// src/Components/Email/EmailList.js
import React, {useEffect} from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setSort, selectEmail, fetchEmailContent } from '../../slices/emailSlice';
import AttachmentIcon from '@mui/icons-material/AttachFile';
import dayjs from 'dayjs';
import {Box } from '@mui/material';
import '../../css/Emails.css';

const EmailList = () => {
  const dispatch = useDispatch();
  const emails = useSelector((state) => state.emails.emails);
  const sortField = useSelector((state) => state.emails.sortField);
  const sortDirection = useSelector((state) => state.emails.sortDirection);
  const selectedbox = useSelector((state) => state.emails.mailbox);
  const selectedTab = useSelector(state => state.uislice.selectedTab, shallowEqual)
  const handleSortModelChange = (model) => {
    if (model.length > 0) {
      dispatch(setSort({ field: model[0].field }));
    }
  };

  const handleRowClick = (params) => {
    dispatch(selectEmail(params.row));
  };


  const columns = [
    {
      field: 'from',
      headerName: 'From',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'to',
      headerName: 'To',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'subject',
      headerName: 'Subject',
      flex: 2,
      minWidth: 200,
    },
    {
      field: 'date',
      headerName: 'Date',
      type: 'dateTime',
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => new Date(params),
      valueFormatter: (params) => new Date(params).toLocaleString() // dayjs(params).format('DD/MM/YYYY HH:mm'),
    },
    {
      field: 'size',
      headerName: 'Size',
      flex: 0.5,
      minWidth: 100,
      valueFormatter: (value ) => `${Math.round((parseInt(value) || 0) / 1024)} KB`,
    },
    {
      field: 'hasAttachment',
      headerName: '📎',
      minWidth: 50,
      width: 50,
      sortable: false,
      renderCell: (params) => (params.value ? <AttachmentIcon fontSize="small" /> : ''),
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '70vh', // This gives the full container height
        width: '100%',
      }}
    >      {(emails??[]).length > 0 && (columns??[]).length > 0 &&
      <Box sx={{flex: 1, height: '100%'}} >
      <DataGrid
        sx={{
          height: '100%',
          width: '100%',}}
        rows={
          (emails??[]).map((email, index) => ({ id: index, ...email }))}
        columns={columns}
        pageSize={25}
        rowsPerPageOptions={[25, 50, 100]}
        onRowClick={handleRowClick}
        sortingOrder={[sortDirection]}
        sortModel={[
          {
            field: sortField,
            sort: sortDirection,
          },
        ]}
        onSortModelChange={handleSortModelChange}
        disableSelectionOnClick
        getRowHeight={() => 'auto'}
      />
      </Box>
      }
    </Box>
  );
};

export default EmailList;
